// This file is auto-generated by the generateCdnImageSizes.js script.
// To add new base sizes, go to:
// https://bitbucket.org/welearngmbh/welearn-assets-cdn-utils/src/master/src/image-resizer/cloudfront-viewer-request/helper/assert-allowed-size.js

export const CdnImageSizes = {
    // 1:1
    '18x18': [18, 18],
    '32x32': [32, 32],
    '50x50': [50, 50],
    '72x72': [72, 72],
    '84x84': [84, 84],
    '88x88': [88, 88],
    '100x100': [100, 100],
    '104x104': [104, 104],
    '132x132': [132, 132],
    '150x150': [150, 150],
    '250x250': [250, 250],
    '288x288': [288, 288],
    '320x320': [320, 320],
    '335x335': [335, 335],
    '400x400': [400, 400],
    '800x800': [800, 800],
    // 14:5
    '280x100': [280, 100],
    // 16:9
    '320x180': [320, 180],
    '400x225': [400, 225],
    '800x450': [800, 450],
    '1200x675': [1200, 675],
    // 7:4
    '350x200': [350, 200],
    // 8:5
    '800x500': [800, 500],
    // 8:9
    '440x495': [440, 495],
    '880x990': [880, 990],
    // 9:16
    '450x800': [450, 800],
    // 9:8
    '540x480': [540, 480],
    // Other
    '68x38': [68, 38],
    '76x85': [76, 85],
    '83x100': [83, 100],
    '87x85': [87, 85],
    '89x100': [89, 100],
    '95x53': [95, 53],
    '96x100': [96, 100],
    '102x100': [102, 100],
    '180x65': [180, 65],
    '185x104': [185, 104],
    '200x183': [200, 183],
    '232x45': [232, 45],
    '240x50': [240, 50],
    '241x152': [241, 152],
    '250x288': [250, 288],
    '250x143': [250, 143],
    '290x164': [290, 164],
    '301x433': [301, 433],
    '318x393': [318, 393],
    '320x133': [320, 133],
    '320x210': [320, 210],
    '326x485': [326, 485],
    '334x654': [334, 654],
    '334x217': [334, 217],
    '375x480': [375, 480],
    '375x133': [375, 133],
    '375x256': [375, 256],
    '375x210': [375, 210],
    '386x200': [386, 200],
    '400x711': [400, 711],
    '479x100': [479, 100],
    '500x281': [500, 281],
    '515x100': [515, 100],
    '535x577': [535, 577],
    '535x427': [535, 427],
    '535x477': [535, 477],
    '539x429': [539, 429],
    '592x640': [592, 640],
    '592x534': [592, 534],
    '592x535': [592, 535],
    '604x746': [604, 746],
    '768x710': [768, 710],
    '768x272': [768, 272],
    '960x470': [960, 470],
    '1023x575': [1023, 575],
    '1150x710': [1150, 710],
    '1150x470': [1150, 470],
    '1232x710': [1232, 710],
    '1232x470': [1232, 470],
    '1330x710': [1330, 710],
    '1330x470': [1330, 470],
} as const;

export const CdnImageFactors = [1, 1.5, 2, 3, 3.5] as const;
